module.exports = __webpack_public_path__ + "img/doctor.5c871fb3.png";